import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Img from "gatsby-image";
import style from "./CaseStudy.module.scss";
import HoverEffect from "../_Common/HoverEffect";

const CaseStudy = ({ url, clientName, shortDescription, coverImage }) => {
  return (
    <div>
      <Link to={url} className={style.caseStudy}>
        <HoverEffect>
          <Img fluid={coverImage.fluid} />
        </HoverEffect>
        <div>
          <h1>{clientName}</h1>
          <h2>{shortDescription}</h2>
        </div>
      </Link>
    </div>
  );
};

CaseStudy.propTypes = {
  url: PropTypes.string.isRequired,
  clientName: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  coverImage: PropTypes.object.isRequired
};

export default CaseStudy;
